import { loadNg1Module, ngmodule } from '../../bootstrap/ngmodule'
import { customerTasksitesComponent } from './containers/list/list.component'
import { tasksiteSearchConfig } from './containers/search/search.component'
import { taskSiteStateFilter } from './filters/tasksite-state.filter'
import { customerTasksitesState } from './tasksites.states'

const tasksitesModule = {
  components: { customerTasksitesComponent },
  states: [customerTasksitesState],
  configBlocks: [tasksiteSearchConfig],
  filters: { taskSiteStateFilter },
}

loadNg1Module(ngmodule, tasksitesModule)



// WEBPACK FOOTER //
// ./app/tasksites/tasksites.module.js